import { configureStore } from "@reduxjs/toolkit";
const createStore = (reducers, initialState, extraArgument) => {
  const reducer = Object.fromEntries(reducers.map((r) => [r.key, r.reducer]));
  return configureStore({
    reducer,
    preloadedState: initialState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      serializableCheck: false,
      immutableCheck: false,
      thunk: {
        extraArgument
      }
    })
  });
};
export default createStore;
